:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-1{flex-shrink:1;}
:root ._fd-column{flex-direction:column;}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}
:root ._grow-1{flex-grow:1;}
:root ._ml--24px{margin-left:-24px;}
:root ._shrink-0{flex-shrink:0;}
:root ._btc-divider{border-top-color:var(--divider);}
:root ._btw-1px{border-top-width:1px;}
:root ._mt-t-space-med104641{margin-top:var(--t-space-medium);}
:root ._pt-t-space-med104641{padding-top:var(--t-space-medium);}
:root ._borderTopStyle-solid{border-top-style:solid;}
:root ._fd-row{flex-direction:row;}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}
:root ._items-center{align-items:center;}
:root ._pr-163px{padding-right:163px;}
@media (max-width: 430px){:root:root ._pr-_xs_134px{padding-right:134px;}}